// components/Common/Unauthorized.js
const Unauthorized = () => {
  return <h2>Acceso no autorizado</h2>;
};

export default Unauthorized;
